import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/auth/auth.guard';
import { TimeEntryMethodGuard } from './services/guards/time-entry-method.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/app/home',
    pathMatch: 'full',
  },
  {
    path: 'auth/login',
    loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'auth/forgotpassword',
    loadChildren: () => import('./pages/forgotpassword/forgotpassword.module').then(m => m.ForgotpasswordPageModule),
  },
  {
    path: 'privacyPolicy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule),
  },
  {
    path: 'termsOfService',
    loadChildren: () => import('./pages/terms-of-service/terms-of-service.module').then(m => m.TermsOfServicePageModule),
  },
  {
    path: 'locationPermissionRequired',
    loadChildren: () => import('./pages/locationPermissionRequired/location-permission-required.module').then(m => m.LocationPermissionRequiredPageModule),
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'logout',
    loadChildren: () => import('./pages/auth/login/login.module').then(m => m.LoginPageModule),
  },
  {
    path: 'addActivity',
    loadChildren: () => import('./pages/activityLog/activityLog.module').then(m => m.ActivityLogPageModule),
  },
  {
    path: 'app/tutorial',
    loadChildren: () => import('./pages/tutorial/tutorial.module').then(m => m.TutorialPageModule),
    canActivate: [TimeEntryMethodGuard],
    data:  { timeEntryPolicy: { redirectMap: TimeEntryMethodGuard.CLOCK_ENTRY_PAGES_DEFAULT_REDIRECT_MAP } }
  },
  {
    path: 'app/messagecenter',
    loadChildren: () => import('./pages/messagecenter/messagecenter.module').then(m => m.MessagecenterPageModule),
  },
  {
    path: 'app/dbview',
    loadChildren: () => import('./pages/dbview/dbview.module').then(m => m.DbviewPageModule),
  },
  {
    path: 'team-project',
    loadChildren: () => import('./pages/team-project/team-project.module').then(m => m.TeamProjectPageModule),
  },
  {
    path: 'downloadMasters',
    loadChildren: () => import('./pages/downloadMasters/downloadMasters.module').then(m => m.DownloadMastersPageModule),
  },
  {
    path: 'forms',
    loadChildren: () => import('./pages/forms/forms.module').then(m => m.FormsPageModule),
  },
  {
    path: 'virtual-badge',
    loadChildren: () => import('./pages/virtual-badge/virtual-badge.module').then(m => m.VirtualBadgePageModule),
  },
  {
    path: 'syncCenter',
    loadChildren: () => import('./pages/sync-center/sync-center.module').then(m => m.SyncCenterPageModule),
  },
  { path: '**', pathMatch: 'full', redirectTo: '/app/home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
